module.exports = __webpack_public_path__ + "static/media/3DPPA30.00768461.jpg";